import React from 'react';

const Standing = (props) => (
    <svg viewBox="0 0 500 500" width={34} height={34}>
        <path fill={props.color || '#000'} d="M336.6,242.26v36.3h-37.4v-42.4c0-7.39-2.59-13.77-8.79-16.84c-0.13-0.2-0.28-0.38-0.45-0.58v202.07h-37.58V307.62h-12.5 v113.19l-31.5-0.61h-6.93V219.87c-5.63,3.25-9.4,9.32-9.4,16.29v42.4H154v-36.3c0-46.67,37.83-84.5,84.51-84.5h13.58 C298.77,157.76,336.6,195.59,336.6,242.26z"/>
        <circle fill={props.color || '#000'} cx="245.3" cy="109.83" r="36.28"/>
    </svg>
);

export default Standing;